// extracted by mini-css-extract-plugin
export default {"tabLoaderWrap":"TabLoader_tabLoaderWrap__noKFd","loader":"TabLoader_loader__sVtYE","spinReverse":"TabLoader_spinReverse__tYme7"};